// extracted by mini-css-extract-plugin
export var avatarContainer = "_cf-0";
export var avatarTypingWave = "_cf-i";
export var gray = "_cf-f";
export var green = "_cf-c";
export var icon = "_cf-9";
export var image = "_cf-1";
export var lg = "_cf-6";
export var md = "_cf-5";
export var presenceDot = "_cf-b";
export var red = "_cf-d";
export var sm = "_cf-4";
export var status = "_cf-a";
export var typingDot = "_cf-h";
export var typingPill = "_cf-g";
export var xl = "_cf-7";
export var xs = "_cf-3";
export var xxl = "_cf-8";
export var xxs = "_cf-2";
export var yellow = "_cf-e";